import React from "react";
import {useDispatch} from "react-redux";
import {Avatar, Popover} from "antd";
import {userSignOut} from "../../appRedux/actions/Auth";
// "appRedux/actions/Auth";

const UserProfile = () => {
  const dispatch = useDispatch();
  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>My Account</li>
      <li>Connections</li>
      <li onClick={() => dispatch(userSignOut())}>Logout
      </li>
    </ul>
  );

  return (

    <div className="gx-flex-row gx-align-items-center gx-avatar-row user-name-box">
      <Popover placement="bottomRight" content={userMenuOptions} trigger="">
        <Avatar src={"https://via.placeholder.com/150x150"}
                className="gx-size-40 gx-pointer gx-mr-3 d-none" alt=""/>
        <span className="gx-avatar-name user-name">Admin<i
          className="icon icon-chevron-down gx-fs-xxs gx-ml-2 d-none"/></span>
      </Popover>
    </div>

  )
};

export default UserProfile;
